
@if (showCountdown()) {
<div class="session-warning-modal">
  <div class="modal-content">
    <div class="modal-flex-row">
      <div class="icon-col">
        <span class="icon-circle"><span class="icon-exclamation">!</span></span>
      </div>
      <div class="content-col">
        <div class="headline">You've been inactive for a while.</div>
        <div class="subtext">For security, you will be logged out in <span class="countdown">{{ countdown() }}</span> seconds.</div>
      </div>
    </div>
    <div class="button-row">
      <button class="continue-btn" (click)="continueSession.emit();">CONTINUE</button>
    </div>
  </div>
</div>
}
